import { render, staticRenderFns } from "./ParticipantStatusLabel.vue?vue&type=template&id=34fd66c6&"
import script from "./ParticipantStatusLabel.vue?vue&type=script&lang=js&"
export * from "./ParticipantStatusLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports